import React, { Component } from 'react';
import TaggedImage from './../taggedImage';
import { withController, Parallax } from 'react-scroll-parallax';
import "./lookBookCenteredOnePhotoAndColor.css";

export class LookBookCenteredOnePhotoAndColor extends Component {
  onImageLoad = () =>{
    this.props.parallaxController.update();
  }

  render() {
    let backgroundColor = this.props.backgroundColor ? this.props.backgroundColor : "#f9f9f9";
    let backgroundImage = this.props.backgroundImage ? 'url('+this.props.backgroundImage+')' : null;
    let backgroundCss = backgroundImage ? backgroundImage : backgroundColor;
    let image = this.props.image;
    let latlng = this.props.latlng;

    return(
      <div
        style={{
          position:'relative',
          marginTop: "10%",
          marginBottom: "5%",
        }}
      >
        <div
          className="full-width large-padding centered-text"
          style={{
            position:'absolute',
            background:backgroundCss,
            height:'100%',
            top: this.props.direction == "bottom" ? "0%": "10%",
            bottom:"0px"
          }}
        ></div>
        <Parallax y={[-10, 0]}>
        <div
          className="lookbook-centered-one-photo-and-color"
          style={{
            margin:'auto',
            paddingTop: this.props.direction == "bottom" ? "10%": "0%",
            paddingBottom: this.props.direction == "bottom" ? "0%": "5%"
          }}
        >
          {latlng ?
            <TaggedImage
              image={image}
              latlng={latlng}
              city={this.props.city}
            />

          :
            <img className="full-width"
              onLoad={this.onImageLoad}
              src={image}
            />
          }
        </div>
        </Parallax>
      </div>
    )
  }
}

export default withController(LookBookCenteredOnePhotoAndColor);



// WEBPACK FOOTER //
// ./src/components/lookBookOnePhotoAndColor/index.js